import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import global_msg from '@/common/js/global.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 所有任务列表
    newslist: [],
    total: 0
  },
  getters: {
    //类似于computed计算属性
  },
  mutations: {
    //用commit来触发某一个方法
    initList(state,data){
      state.newslist = data.list
      state.total = data.total
    }
  },
  actions: {
    //用dispatch来触发某一个方法
    getData(context,page){
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=公司新闻&page.currentPage=' + page + '&page.showCount=10').then((response) => {
        console.log(response)
        context.commit({
          type: 'initList',
          list: response.data.subject.result,
          total: response.data.subject.totalCount
        })
      });
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js